import styled from 'styled-components';
import emptyState from './images/empty-state.svg';
import emptyStateDark from './images/empty-state-dark.svg';
import errorState from './images/error-state.svg';

export const PageViewPortWorkspaceRedesign = styled.div`
  background-color: ${(props) => props.theme.themeId === 'dark' ? props.theme['color.black'] : props.theme['color.background']};
`;

export const EmptyStateImageWrapper = styled.div`
  background-image: url(${(props) => props.theme.themeId === 'dark' ? emptyStateDark : emptyState});
  width: 265px;
  height: 185px;
  background-size: cover;
`;

export const EmptyStateWrapper = styled.div `
  padding-top: 100px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const ErrorStateImageWrapper = styled.div`
  background-image: url(${errorState});
  width: 108px;
  height: 108px;
  background-size: cover;
`;

export const MessageParagraph = styled.p`
  margin: 0;
  max-width: 960px;
`;

export const EmptyContentWrapper = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
`;

export const ErrorContentWrapper = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
`;